import { render } from "./ErrorSnackbar.vue?vue&type=template&id=261c4140&ts=true"
import script from "./ErrorSnackbar.vue?vue&type=script&lang=ts"
export * from "./ErrorSnackbar.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__